export default __webpack_public_path__ + "static/media/poly.af736b21.png";